module.exports = __webpack_public_path__ + "static/sre-white-de0c55cbe3dc21dc4449521b677fcfac.jpg";